import React, { FC, SyntheticEvent, useState } from 'react';
import usePermittedSessionPreferences from 'hooks/usePermittedSessionPreferences';
import useUpdateSessionPreferences from 'hooks/useUpdateSessionPreferences';
import PaymentError from '../Error/PaymentError';
import { PaymentErrorProps, PaymentErrorType } from 'api/data/payment/types';
import { Response } from 'api/data/response/types';
import './style.scss';

interface TapToPayProps {
  onSubmit: () => void;
  pageId?: string;
  response: Response;
  paymentError?: PaymentErrorProps;
  setLoading: (loading: boolean) => void;
  loading: boolean;
  spaceSlug?: string;
  buttonText?: string;
}

const TapToPay: FC<TapToPayProps> = ({
  onSubmit,
  pageId,
  response,
  paymentError,
  setLoading,
  loading,
  spaceSlug,
  buttonText,
}) => {
  const [errorMessage, setErrorMessage] = useState<string>();
  const { tapToPay } = usePermittedSessionPreferences(spaceSlug || '');
  const [mobileMessage, setMobileMessage] = useState('');
  const updateSessionPreferences = useUpdateSessionPreferences(spaceSlug || '');

  const enableTapToPay = async () => {
    if (tapToPay) return;

    const input = { acceptInPersonPayments: true, tapToPay: true };

    await updateSessionPreferences(input);
  };

  const sendMessageToMobile = () => {
    const payload = {
      message: 'charge_tap_to_pay',
      payload: {
        clientSecret: 'some id from be',
      },
    };
    window.ReactNativeWebView?.postMessage(JSON.stringify(payload));
    setMobileMessage('Enabled!');
  };

  const handleSubmit = async (event: SyntheticEvent) => {
    event.preventDefault();
    setLoading(true);
    setErrorMessage('');

    try {
      await enableTapToPay();
      sendMessageToMobile();
      onSubmit();
    } catch (error) {
      setErrorMessage((error as PaymentErrorType).message);
    } finally {
      setLoading(false);
    }
  };

  const isSubmitDisabled = loading || (!!pageId && response.order.totalCents === 0);

  return (
    <div className="tap-to-pay-container">
      {!loading && errorMessage && <PaymentError title={paymentError?.title} errorMessage={errorMessage} />}
      <form
        onSubmit={event => void handleSubmit(event)}
        className="payment-method"
        aria-label="tap to pay payment form">
        <button type="submit" disabled={isSubmitDisabled}>
          {loading ? 'Processing...' : buttonText}
        </button>
        <span className="subtitle-xx-small neutral">{mobileMessage}</span>
      </form>
    </div>
  );
};

export default TapToPay;
